/*
 * @Author: fengqianhui
 * @Date: 2024-03-27 16:06:28
 * @LastEditors: fengqianhui fengqianhui@wedobest.com.cn
 * @LastEditTime: 2024-07-31 15:14:31
 * @FilePath: \landingpage\src\main.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import App from '@/App.vue';
import router from './router';

import './styles/main.less';
// svg icon
import 'virtual:svg-icons-register';

const app = createApp(App);

// 针对页面中的操作增加了权限判断 读、读写权限
// 两个传值 permissionValue:对应页面 permissionArr:userInfo中的权限数组
app.directive('permission', {
  mounted(el, binding) {
    const permissions = binding.value?.permissionArr;
    const permissionValue = binding.value?.permissionValue;
    if (permissions?.filter((item: string) => item === '*')?.length) return;
    const arr = permissions?.filter((item: string[]) => item.includes(permissionValue));
    if (!arr?.filter((item: string) => item === permissionValue + ':*')?.length) el.style.display = 'none';
  },
  beforeUpdate(el, binding) {
    const { value, oldValue } = binding;
    const flag = JSON.stringify(value) === JSON.stringify(oldValue);
    if (flag) return;
    const permissions = value?.permissionArr;
    const permissionValue = value?.permissionValue;
    if (permissions?.filter((item: string) => item === '*')?.length) return (el.style.display = 'initial');
    const arr = permissions?.filter((item: string[]) => item.includes(permissionValue));
    if (!arr?.filter((item: string) => item === permissionValue + ':*')?.length) {
      el.style.display = 'none';
    } else {
      el.style.display = 'initial';
    }
    return;
  },
});

if (import.meta.env.VITE_DOMAIN === 'prod') {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_APP_SENTRY,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

app.use(createPinia());
app.use(router);

app.mount('#app');
